<template>
  <div class="w12">
    <asset-header></asset-header>
    <div v-if="userInfo.foreignYn == 'Y'">
      <div class="foreign pl12 mt10 mb50">
        {{ $t("deposit.onlyKoreanCanUseKrwMarket") }}
      </div>
    </div>
    <div v-else>
      <!-- 가상계좌 전까지 사용할 원화 입금 중지 문구 -->
      <div class="obstruct-wrap pt20 pb50">
        <div class="title">
          {{ "원화 입금 중지" }}
        </div>
        <div class="text-box">
          <p>{{ "안전하고 원활한 입금 지원을 위해 중지 중입니다." }}</p>
          <p>{{ "회원님들의 많은 양해 부탁 드립니다." }}</p>
        </div>
      </div>
    </div>
    <!-- // 가상계좌 전까지 사용할 원화 입금 중지 문구 -->
    <!-- 가상계좌 후에 사용할 원화 입금 일시 중지 문구 -->
    <!-- <div v-if="getCoinSetting('KRW').ioInEnable == 'N'" class="obstruct-wrap">
        <div class="title">
          {{ $t("withdraw.obstruct.deposit", [$t("원화")]) }}
        </div>
        <div class="text-box">
          <p>{{ $t("withdraw.obstructNoti.deposit[0]") }}</p>
          <p>{{ $t("withdraw.obstructNoti.deposit[1]") }}</p>
        </div>
      </div> -->
    <!-- // 가상계좌 후에 사용할 원화 입금 일시 중지 문구 -->

    <!-- 가상계좌 후 살릴 코드 -->
    <!-- <div v-else class="w12">
        <div class="w12 padding-content top-noti">
          <div class="text-wrap">
            <img src="../../../assets/img/mypage/check-icon.svg" alt="" />
            <div class="content default" v-html="$t('deposit.입출금시')"></div>
          </div>
        </div>

        <div class="top-accounts-wrap fs12 pb48">
          <div class="account-box virtual-account">
            <div class="top-logo">
              <img
                src="../../../assets/img/mypage/flybit-small-logo.svg"
                alt=""
              />
            </div>
            <div class="bottom-text mt12">
              <div class="bank-name" flex>
                <p class="w-size">{{ "은행명" }}</p>
                <p v-if="accounts.vrAccount !== null">
                  {{ userInfo.accounts.vrAccount.bankName }}
                </p>
              </div>
              <div class="user-name mt8" flex>
                <p class="w-size">{{ "예금주명" }}</p>
                <p class="">{{ userInfo.name }}</p>
              </div>
              <div class="bank-account mt11" flex>
                <p class="text w-size">{{ "은행계좌" }}</p>
                <p
                  v-if="accounts.vrAccount !== null"
                  class="fs24 keycolor number"
                >
                  {{ userInfo.accounts.vrAccount.accountNumber }}
                </p>
              </div>
            </div>
          </div>
          <div @click="copyAddrMemo" class="copy-wrap mt12">
            <div class="copy-button" flex>
              <p>입금계좌 번호 복사</p>
              <div class="copy-icon ml4">
                <img src="../../../assets/img/trade/copy-icon.png" alt="" />
              </div>
            </div>
          </div>
          <div class="arrow-icon mt8">
            <img src="../../../assets/img/mypage/uparrow-icon.svg" alt="" />
            <p class="fs12 pt21 colorGray">계좌이체</p>
          </div>
          <div class="account-box mt8">
            <div class="top-logo">
              <img
                src="../../../assets/img/mypage/busan-small-logo.svg"
                alt=""
              />
            </div>
            <div class="bottom-text busan-account mt25">
              <div class="user-name w-size" flex>
                <p>{{ "예금주명" }}</p>
                <p class="ml10">{{ userInfo.name }}</p>
              </div>
              <div class="bank-account mt8" flex>
                <p>{{ "은행계좌" }}</p>
                <p v-if="accounts.vrAccount !== null" class="ml10">
                  <span v-if="Server.version < 10">{{
                    accountMasking(userInfo.accounts.deposit.accountNumber)
                  }}</span>
                  <span v-else>{{
                    userInfo.accounts.deposit.accountNumber
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    <!-- // 가상계좌 후 살릴 코드 -->
    <div class="noti-box">
      <div class="noti-title ml10">
        <img src="../../../assets/img/icon/ico_exclamation.png" />
        <span class="fs14">{{ $t("deposit.꼭 확인해주세요.제목") }}</span>
      </div>
      <!-- <ul class="no-dot pl12 pr12"> -->
      <ul class="pl12 pr12">
        <li class="red">
          <span class="c-main fs12">{{
            $t("deposit.꼭 확인해주세요.내용[0]")
          }}</span>
        </li>
        <li class="red">
          <span class="c-main fs12">{{
            $t("deposit.꼭 확인해주세요.내용[1]")
          }}</span>
          <br />
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[2]") }}</span>
        </li>
        <li>
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[3]") }}</span>
          <br />
          {{ $t("deposit.꼭 확인해주세요.내용[4]") }}
        </li>
        <li>
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[5]") }}</span>
          <br />
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[6]") }}</span>
          <br />
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[7]") }}</span>
        </li>
        <li>
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[8]") }}</span>
        </li>
        <li>
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[9]") }}</span>
        </li>
        <li>
          <span class="fs12">{{ $t("deposit.꼭 확인해주세요.내용[10]") }}</span>
        </li>
      </ul>
    </div>
    <!-- #endregion 입금 신청 내역 -->

    <!-- #region 본인인증&계좌등록 필요 안내 -->
    <el-dialog
      :title="$t('selfCertification.title')"
      :visible.sync="accountAuthFailModal.show"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p
          class="text-type01 mgb25"
          v-html="$t('selfCertification.verificationAccountRegistration')"
        ></p>
      </div>
      <span slot="footer" class="dialog-footer" flex fic fjc>
        <button class="btn-style01" @click="$router.go(-1)">
          {{ $t("confirm.cancel") }}
        </button>
        <router-link tag="button" :to="{ name: 'confirm' }" class>{{
          $t("confirm.ok")
        }}</router-link>
      </span>
    </el-dialog>
    <!-- #endregion 본인인증&계좌등록 필요 안내 -->

    <!-- #region 외국인 원화 입출금 제한 안내 -->
    <el-dialog
      title="안내"
      :visible.sync="foreignNotAllowedModal.show"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p class="text-type01 mgb25">
          Only Korean Nationals can use the KRW market.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="foreignNotAllowedModal.show = false">
          <span @click="$router.go(-1)" class="btn-style01">{{
            $t("confirm.ok")
          }}</span>
        </span>
      </span>
    </el-dialog>
    <!-- #endregion 외국인 원화 입출금 제한 안내 -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

import Api from "@/common/Api";
import CookieControl from "@/common/CookieControl";
// import UploadRemit from "@/components/depositWithdraw/deposit/uploadRemit";
import Moment from "moment";
import AssetHeader from "../component/asset/header";
import Clipboard from "copy-to-clipboard";
import GlobalEvent from "@/common/Event";
import Masking from "@/common/masking.js";

export default {
  components: {
    AssetHeader,
  },
  created() {
    //
    if (this.$store.getters.isLogin) {
      this.loginContent = true;
    } else {
      this.loginContent = false;
    }

    // 본인 인증 & 계좌 등록 여부 확인
    if (this.accounts.vrAccount == null) {
      this.accountModal = true;
      // this.accountAuthFailModal.show = true;
      return false;
    }
    // this.getRemittanceHistory();
  },
  data() {
    return {
      isKrw: true,
      krwValue: "",
      loginContent: true,

      certListModal: {
        show: false,
        busy: false,
        certList: [],
        certPasswd: "",
        selectedCert: {},
      },
      accountAuthFailModal: {
        show: false,
      },
      foreignNotAllowedModal: {
        show: false,
      },
      iSASInstallModal: {
        show: false,
      },
      selectTransModal: {
        show: false,
        busy: false,
        fromDate: Moment()
          .subtract(3, "d")
          .startOf("day"),
        toDate: Moment().startOf("day"),
        list: [],
        selected: {},
        //flood
        //selected: [],
        privacyCheck: false,
        showConfirm: false,
      },
      uploadRemitModal: false,
      currentRow: null,
      untilTodayOption: {
        disabledDate(time) {
          return !_.inRange(
            time.getTime(),
            +Moment()
              .subtract(3, "months")
              .startOf("day"),
            Date.now()
          );
        },
      },
      remittances: [],
      statusKRW: {
        TX_STATUS: "",
      },
      accountModal: false, //입금계좌 미발급 시 팝업
    };
  },
  computed: {
    ...mapGetters([
      "dexkoInfo",
      "bankList",
      "authStep",
      "accounts",
      "userName",
      "userInfo",
      "isLogin",
      "getCoinSetting",
    ]),
    ...mapState(["Server"]),
    // 인증서 정보
    certParam() {
      if (!this.certListModal.selectedCert) {
        return {};
      }
      const cert = { ...this.certListModal.selectedCert };
    },
    selectedBank() {
      return _.get(this.bankInfo, [this.certListModal.bank], { Input: [] });
    },
    selectTransDays() {
      const from = Moment(this.selectTransModal.fromDate);
      const to = Moment(this.selectTransModal.toDate);
      return Moment.duration(to.diff(from)).days();
    },
    selectTransReady() {
      return (
        this.selectTransModal.privacyCheck &&
        this.$refs.transListTable.selection.length
      );
    },
    canDeposit() {
      const value = Number(`${this.krwValue}`.replace(/,/g, ""));
      if (value >= 1000 && value <= 10000000000) {
        return false;
      } else {
        return true;
      }
    },
    // wlf 사유 코드 분기
    wlfcontents() {
      if (this.userInfo.dueDiligenceInfo) {
        const code = this.userInfo.dueDiligenceInfo.wlfContents;
        switch (code) {
          case "01":
            return "금융위원회에서 고시하는 금융거래제한대상자";
          case "02":
            return "FATF 지정 위험국가 국적자 또는 거주자";
          case "03":
            return "FATF 지정 위험국가 국적자 또는 거주자";
          case "04":
            return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
          case "05":
            return "UN에서 지정하는 제재대상자";
          case "06":
            return "외국의 정치적 주요 인물";
          case "07":
            return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
          case "08":
            return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
          case "09":
            return "";
          case "10":
            return "당사에서 자금세탁행위등의 위험을 우려하여 지정한 거래제한 국가";
          default:
            break;
        }
        return;
      }
    },
  },
  methods: {
    selectTrans(tansaction) {},
    // copy
    copyAddrMemo() {
      Clipboard(this.userInfo.accounts.vrAccount.accountNumber);
      this.$notify({
        message: `입금계좌 번호가 복사되었습니다.`,
        position: "top-left",
        customClass: "dexko-noti-black",
      });
    },
    // 마스킹
    // masking(name) {
    //   const masked_name = name.slice(0, -4);
    //   const noneMasked_name = name.slice(name.length - 4);
    //   let masking = "";
    //   for (var i = 0; i < masked_name.length; i++) {
    //     masking = masking + "*";
    //   }
    //   return masking + noneMasked_name;
    // },
    // 계좌번호 마스킹 : 7자리부터 적용
    accountMasking(_value) {
      return Masking.accountMasking(_value);
    },
  },
  watch: {
    krwValue: function(val) {
      const result = `${val}`
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.krwValue = result));
      // this.krwValue = result
    },
  },
};
</script>

<style lang="scss" scoped>
.top-noti {
  padding: 0 12px;
  .text-wrap {
    position: relative;
    border: 1px solid #e6e6e6;
    img {
      position: absolute;
      top: 50%;
      left: 8px;
      transform: translateY(-50%);
    }
  }
}
.obstruct-wrap {
  p {
    margin-bottom: 0;
  }
  width: 100%;
  padding: 0 12px;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .text-box {
    margin-top: 10px;
    padding: 10px;
    background-color: #fafafa;
    border-top: 1px solid #333;
    border-bottom: 1px solid #e6e6e6;
    p {
      font-size: 12px;
      color: #666;
      line-height: 22px;
    }
  }
}
</style>
